import {
  LOGIN_URL,
  ME_URL,
  REGISTER_URL,
  REQUEST_PASSWORD_URL
} from "../_redux/authCrud";
import userTableMock from "./userTableMock";

export const successResponse = { status: "success", message: "Success!", value: { _id: "bobin@zeefasys.com", name: "super user", phoneNumber: "1234567890", email: "bobin@zeefasys.com", role: "super_admin", activationToken: true, preferredLang: "en", userLanguage: "English", assignedFacility: [], iat: 1612261869, exp: 1612276269, token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiJib2JpbkB6ZWVmYXN5cy5jb20iLCJuYW1lIjoic3VwZXIgdXNlciIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsImVtYWlsIjoiYm9iaW5AemVlZmFzeXMuY29tIiwicm9sZSI6InN1cGVyX2FkbWluIiwiYWN0aXZhdGlvblRva2VuIjp0cnVlLCJwcmVmZXJyZWRMYW5nIjoiZW4iLCJ1c2VyTGFuZ3VhZ2UiOiJFbmdsaXNoIiwiYXNzaWduZWRGYWNpbGl0eSI6W10sImlhdCI6MTYxMjI2MTg2OSwiZXhwIjoxNjEyMjY5MDY5fQ.V7u9Y4gWHVL9RFNF75dXvaOAdcAbEqvhwgHCiVljgQUtoKEneyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiJib2JpbkB6ZWVmYXN5cy5jb20iLCJuYW1lIjoic3VwZXIgdXNlciIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsImVtYWlsIjoiYm9iaW5AemVlZmFzeXMuY29tIiwicm9sZSI6InN1cGVyX2FkbWluIiwiYWN0aXZhdGlvblRva2VuIjp0cnVlLCJwcmVmZXJyZWRMYW5nIjoiZW4iLCJ1c2VyTGFuZ3VhZ2UiOiJFbmdsaXNoIiwiYXNzaWduZWRGYWNpbGl0eSI6W10sImlhdCI6MTYxMjI2MTg2OSwiZXhwIjoxNjEyMjc2MjY5fQ.nm-o2PC4FJVo9w0WbawnLOrWAUh8CRxd1eh_Cw1bA-c" }, error_code: "success" };

export default function mockAuth(mock) {
  mock.onPost(LOGIN_URL).reply(({ data }) => {
    const { email, password } = JSON.parse(data);

    if (email && password) {
      const user = userTableMock.find(
        x =>
          x.email.toLowerCase() === email.toLowerCase() &&
          x.password === password
      );

      if (user) {
        return [200, { ...user, password: undefined }];
      }
    }

    return [400];
  });


  mock.onPost(REGISTER_URL).reply(({ data }) => {
    const { email, fullname, username, password } = JSON.parse(data);

    if (email && fullname && username && password) {
      const user = {
        id: generateUserId(),
        email,
        fullname,
        username,
        password,
        roles: [2], // Manager
        accessToken: "access-token-" + Math.random(),
        refreshToken: "access-token-" + Math.random(),
        pic: process.env.PUBLIC_URL + "/media/users/default.jpg"
      };

      userTableMock.push(user);

      return [200, { ...user, password: undefined }];
    }

    return [400];
  });

  mock.onPost(REQUEST_PASSWORD_URL).reply(({ data }) => {
    const { email } = JSON.parse(data);

    if (email) {
      const user = userTableMock.find(
        x => x.email.toLowerCase() === email.toLowerCase()
      );

      if (user) {
        user.password = undefined;

        return [200, { ...user, password: undefined }];
      }
    }

    return [400];
  });

  mock.onGet(ME_URL).reply(({ headers: { Authorization } }) => {
    const accessToken =
      Authorization &&
      Authorization.startsWith("Bearer ") &&
      Authorization.slice("Bearer ".length);

    if (accessToken) {
      const user = userTableMock.find(x => x.accessToken === accessToken);

      if (user) {
        return [200, { ...user, password: undefined }];
      }
    }

    return [401];
  });

  function generateUserId() {
    const ids = userTableMock.map(el => el.id);
    const maxId = Math.max(...ids);
    return maxId + 1;
  }

}
